/* =============================================
   Scale Code — Main JS v5.0
   Vanilla JS | No dependencies | Null-safe
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* ---- 1. Loader ---- */
  const loader = document.getElementById('loader');
  if (loader) {
    setTimeout(() => { loader.classList.add('done'); document.body.classList.add('loaded'); }, 1600);
  } else {
    document.body.classList.add('loaded');
  }

  /* custom cursor removed for performance */

  /* ---- 3. Nav scroll handler ---- */
  const nav = document.querySelector('.sc-nav') || document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.window.scrollY > 40);
    }, { passive: true });
  }

  /* ---- 14. Staggered children (run before reveal observer) ---- */
  document.querySelectorAll('.stagger-children').forEach(container => {
    container.querySelectorAll('.reveal').forEach((child, i) => {
      child.dataset.delay = i * 80;
    });
  });

  /* ---- 4. Scroll Reveal System ---- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const delay = parseInt(e.target.dataset.delay || 0, 10);
          setTimeout(() => e.target.classList.add('visible'), delay);
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(el => revealObs.observe(el));
  }

  /* ---- 5. Counter Animation ---- */
  const counters = document.querySelectorAll('.sc-metric__value[data-target]');
  if (counters.length) {
    const easeOutQuart = t => 1 - Math.pow(1 - t, 4);
    const DUR = 2000;

    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const target = parseFloat(el.dataset.target);
        const decimals = (el.dataset.target.split('.')[1] || '').length;
        const start = performance.now();

        (function tick(now) {
          const p = Math.min((now - start) / DUR, 1);
          el.textContent = (easeOutQuart(p) * target).toFixed(decimals);
          if (p < 1) requestAnimationFrame(tick);
        })(start);

        counterObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(el => counterObs.observe(el));
  }

  /* ---- 6. Text Scramble (on hover) ---- */
  const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*';
  document.querySelectorAll('.scramble').forEach(el => {
    const original = el.textContent;
    let frame = null;

    el.addEventListener('mouseenter', () => {
      let iteration = 0;
      cancelAnimationFrame(frame);
      (function scramble() {
        el.textContent = original.split('').map((c, i) =>
          i < iteration ? original[i] : CHARS[Math.floor(Math.random() * CHARS.length)]
        ).join('');
        if (iteration < original.length) { iteration += 1; frame = requestAnimationFrame(scramble); }
      })();
    }, { passive: true });

    el.addEventListener('mouseleave', () => {
      cancelAnimationFrame(frame);
      el.textContent = original;
    }, { passive: true });
  });

  /* spotlight removed for perf */

  /* magnetic removed for perf */

  /* ---- 9. Blur Reveal ---- */
  const blurEls = document.querySelectorAll('.blur-reveal');
  if (blurEls.length) {
    blurEls.forEach(el => {
      const words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(w => `<span class="word">${w}</span>`).join(' ');
    });

    const blurObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('active'); blurObs.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    blurEls.forEach(el => blurObs.observe(el));
  }

  /* ---- 10. CTA Glow ---- */
  const cta = document.querySelector('.sc-cta');
  if (cta) {
    cta.addEventListener('mousemove', (e) => {
      const r = cta.getBoundingClientRect();
      const x = e.clientX - r.left, y = e.clientY - r.top;
      cta.style.background = `radial-gradient(circle at ${x}px ${y}px, rgba(99,102,241,.15) 0%, transparent 60%)`;
    }, { passive: true });

    cta.addEventListener('mouseleave', () => { cta.style.background = ''; }, { passive: true });
  }

  /* ---- 11. Marquee speed on scroll ---- */
  const marquees = document.querySelectorAll('.sc-marquee__content, .sc-brands__track, .sc-partners__track');
  if (marquees.length) {
    let lastY = window.window.scrollY;
    window.addEventListener('scroll', () => {
      const dir = window.window.scrollY > lastY ? 1 : -1;
      const speed = dir > 0 ? 0.5 : 2;
      marquees.forEach(m => { m.style.animationDuration = `${speed * 20}s`; });
      lastY = window.window.scrollY;
    }, { passive: true });
  }

  /* ---- 12. Smooth anchor scroll ---- */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  /* ---- 13. Horizontal scroll drag ---- */
  const scrollWrap = document.querySelector('.sc-results__scroll');
  if (scrollWrap) {
    let isDown = false, startX, scrollLeft;
    scrollWrap.addEventListener('mousedown', (e) => {
      isDown = true; scrollWrap.classList.add('dragging');
      startX = e.pageX - scrollWrap.offsetLeft;
      scrollLeft = scrollWrap.scrollLeft;
    });
    scrollWrap.addEventListener('mouseleave', () => { isDown = false; scrollWrap.classList.remove('dragging'); }, { passive: true });
    scrollWrap.addEventListener('mouseup', () => { isDown = false; scrollWrap.classList.remove('dragging'); }, { passive: true });
    scrollWrap.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - scrollWrap.offsetLeft;
      scrollWrap.scrollLeft = scrollLeft - (x - startX) * 1.5;
    }, { passive: true });
  }

  /* ---- 15. Parallax removed for performance ---- */

  /* ---- 16. Number Ticker ---- */
  const tickers = document.querySelectorAll('.ticker[data-target]');
  if (tickers.length) {
    const tickerObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const target = parseFloat(el.dataset.target);
        const decimals = (el.dataset.target.split('.')[1] || '').length;
        const dur = 2400;
        const start = performance.now();

        (function tick(now) {
          const p = Math.min((now - start) / dur, 1);
          el.textContent = (p * target).toFixed(decimals);
          if (p < 1) requestAnimationFrame(tick);
        })(start);

        tickerObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    tickers.forEach(el => tickerObs.observe(el));
  }

}); /* end DOMContentLoaded */

/* ============================================================
   PREMIUM MOTION EFFECTS — Added on top of working base
   None of the above code is modified. These are additions only.
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* cursor trail removed for performance */

  /* 3D tilt removed for performance */

  /* ---- 3. ACTIVE NAV HIGHLIGHT — accent color on current section ---- */
  const navLinks = document.querySelectorAll('.sc-nav__link, .sc-nav__links a:not(.sc-nav__cta), .pill-nav__links a');
  if (navLinks.length) {
    const sections = [];
    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) sections.push({ link, target });
      }
    });
    window.addEventListener('scroll', () => {
      let current = null;
      sections.forEach(({ link, target }) => {
        const rect = target.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom > 150) current = link;
        link.style.color = '';
        link.style.opacity = '';
      });
      if (current) {
        current.style.color = 'var(--accent, #0EA5E9)';
        current.style.opacity = '1';
      }
    }, { passive: true });
  }

  /* ---- 4. FLOATING BACK TO TOP ---- */
  const btt = document.createElement('button');
  btt.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 15l-6-6-6 6"/></svg>';
  btt.style.cssText = 'position:fixed;bottom:24px;right:24px;width:44px;height:44px;border-radius:50%;background:var(--surface,#18181b);color:var(--text,#fafafa);border:1px solid var(--border,#27272a);display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:998;opacity:0;transform:translateY(12px);transition:all 0.4s cubic-bezier(0.16,1,0.3,1);box-shadow:0 4px 20px rgba(0,0,0,0.15);';
  btt.setAttribute('aria-label', 'Back to top');
  document.body.appendChild(btt);
  btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  window.addEventListener('scroll', () => {
    const show = window.scrollY > 500;
    btt.style.opacity = show ? '1' : '0';
    btt.style.transform = show ? 'translateY(0)' : 'translateY(12px)';
    btt.style.pointerEvents = show ? 'auto' : 'none';
  }, { passive: true });

  /* ---- 5. STICKY MOBILE CTA — removed ---- */

  /* ---- 6. TESTIMONIAL AUTO-ROTATE — disabled, manual tap only ---- */

  /* ---- 8. IMAGE HOVER ZOOM + OVERLAY on portfolio ---- */
  document.querySelectorAll('.sc-portfolio__item, .sc-accordion__item').forEach(item => {
    item.addEventListener('mouseenter', () => {
      const media = item.querySelector('img, video');
      if (media) media.style.transform = 'scale(1.06)';
    });
    item.addEventListener('mouseleave', () => {
      const media = item.querySelector('img, video');
      if (media) media.style.transform = 'scale(1)';
    });
  });

}); /* end premium effects DOMContentLoaded */
